import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { TranslationNS } from '@gokrew/models/constants';
import { Language_Options } from '@gokrew/ui/constants/language-options';
import { frenchElision } from '@gokrew/ui/utility/frenchElision';
import { formatInterpolatedValue } from '@gokrew/ui/utility/localizedNumbers';

const translations = Object.values(TranslationNS);

/* The document language follows the app language, so assistive tech reads
   it right and CSS hyphenation (long French stat labels) uses French rules. */
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n
  //lazy load translation using http -> see /public/locales
  .use(HttpBackend)
  // detect user language
  .use(LanguageDetector)
  // "de Emma" reads "d'Emma" in French translations.
  .use(frenchElision)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // default language
    supportedLngs: Language_Options.map(({ code }) => code),
    ns: translations,
    // i18next reads ten files at a time by default. With every namespace (and
    // the English fallback of each) that is a dozen sequential waves, and the
    // app cannot render until its own namespaces arrive, so the full-page
    // loader sat there for seconds. Over HTTP/2 they can all go at once.
    maxParallelReads: translations.length * 2,
    defaultNS: 'auth',
    postProcess: ['frenchElision'],
    interpolation: {
      escapeValue: false,
      // "8,31 jours" in French: decimals follow the language's separator.
      alwaysFormat: true,
      format: formatInterpolatedValue,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
